export default "__VITE_ASSET__BNr0Cwiq__"